<template>
  <div class="legal-page">
    <div class="container">
      <h1>Terms of Service</h1>
      <p class="last-updated">Last updated: {{ new Date().toLocaleDateString() }}</p>

      <section>
        <h2>1. Agreement to Terms</h2>
        <p>By accessing the website at https://go.l2l.fun, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
      </section>

      <section>
        <h2>2. Use License</h2>
        <p>Permission is granted to temporarily download one copy of the materials (information or software) on L2L.fun's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
        <ul>
          <li>modify or copy the materials;</li>
          <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
          <li>attempt to decompile or reverse engineer any software contained on L2L.fun's website;</li>
          <li>remove any copyright or other proprietary notations from the materials; or</li>
          <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
        </ul>
        <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by L2L.fun at any time.</p>
      </section>

      <section>
        <h2>3. Disclaimer</h2>
        <p>The materials on L2L.fun's website are provided on an 'as is' basis. L2L.fun makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
      </section>

      <section>
        <h2>4. Limitations</h2>
        <p>In no event shall L2L.fun or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on L2L.fun's website, even if L2L.fun or a L2L.fun authorized representative has been notified orally or in writing of the possibility of such damage.</p>
      </section>

      <section>
        <h2>5. Accuracy of Materials</h2>
        <p>The materials appearing on L2L.fun's website could include technical, typographical, or photographic errors. L2L.fun does not warrant that any of the materials on its website are accurate, complete or current. L2L.fun may make changes to the materials contained on its website at any time without notice.</p>
      </section>

      <section>
        <h2>6. Links</h2>
        <p>L2L.fun has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by L2L.fun of the site. Use of any such linked website is at the user's own risk.</p>
      </section>

      <section>
        <h2>7. Modifications</h2>
        <p>L2L.fun may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
      </section>

      <section>
        <h2>8. Governing Law</h2>
        <p>These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
      </section>
      
      <div class="back-link">
        <router-link to="/">← Back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>

<style scoped>
/* Reusing styles from PrivacyPolicy for consistency */
.legal-page {
  padding: 40px 20px;
  color: #fff;
  min-height: 80vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  color: #fff;
}

.last-updated {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 40px;
  font-style: italic;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #e0eaff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

p, li {
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.back-link {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.back-link a {
  display: inline-block;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: white;
  text-decoration: none;
  transition: background 0.3s;
}

.back-link a:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
